module.exports = __webpack_public_path__ + "img/img8.fb759413.png";